import { useHasParentMarket } from './useHasParentMarket';
import { useMarketGoodsCarouselQuery } from '../components/MarketGoodsCarousel/queries/useMarketGoodsCarouselQuery';
import { useParentMarketGoodsCarouselQuery } from '../components/MarketGoodsCarousel/queries/useParentMarketGoodsCarouselQuery';

export const useMarketGoodsCarousels = (marketId: number) => {
  const { hasParentMarket } = useHasParentMarket(marketId);

  const marketGoodsCarouselQuery = useMarketGoodsCarouselQuery(marketId, {
    enabled: hasParentMarket === false,
  });

  const parentMarketGoodsCarouselQuery = useParentMarketGoodsCarouselQuery(
    marketId,
    {
      enabled: hasParentMarket,
    },
  );

  if (hasParentMarket === true) {
    return parentMarketGoodsCarouselQuery;
  }

  return marketGoodsCarouselQuery;
};
